import { FilterToggleOption } from 'app/components/filter-toggle-group/filter-toggle-group.component';
import { CanonicalWorkOrderState, PORTAL_STATE_BY_CANONICAL_STATE, WorkOrderState } from 'app/_models/work-order-state';

// Used by the two work order list pages (PORTAL-6).

export const ACTION_REQUIRED_OPTION = 'ACTION_REQUIRED';

export const WORK_ORDER_OPTION_BUTTONS: FilterToggleOption[] = [
  { key: '', label: 'All', class: 'primary' },
  { key: ACTION_REQUIRED_OPTION, label: 'Action Required', class: 'danger' },
];

// The Status quick-picks. Each picks exactly the rows whose Status badge (work-order-state-badge)
// shows that label, by sending every backend state the badge shows under it
// (workOrderStatesForStatus). Labels and colours are the badge's own.
const ALL_STATUSES: FilterToggleOption = { key: '', label: 'All', class: 'primary' };
const AVAILABLE: FilterToggleOption = { key: 'AVAILABLE', label: 'Available', class: 'primary' };
const SCHEDULED: FilterToggleOption = { key: 'SCHEDULED', label: 'Scheduled', class: 'primary' };
const RESCHEDULE_REQUIRED: FilterToggleOption = { key: 'RESCHEDULE_REQUIRED', label: 'Reschedule Required', class: 'warning' };
const OPEN: FilterToggleOption = { key: 'OPEN', label: 'Open', class: 'success' };
const TRANSFER_REQUESTED: FilterToggleOption = { key: 'TRANSFER_REQUESTED', label: 'Transfer Requested', class: 'danger' };
const RETURN_REQUESTED: FilterToggleOption = { key: 'RETURN_REQUESTED', label: 'Return Requested', class: 'danger' };
const CLOSED: FilterToggleOption = { key: 'CLOSED', label: 'Closed', class: 'default' };
const SUSPENDED: FilterToggleOption = { key: 'SUSPENDED', label: 'Suspended', class: 'warning' };
const SURRENDERED: FilterToggleOption = { key: 'SURRENDERED', label: 'Surrendered', class: 'danger' };
const PENDING_RELEASE: FilterToggleOption = { key: 'PENDING_RELEASE', label: 'Pending Release', class: 'warning' };
const PENDING_APPROVAL: FilterToggleOption = { key: 'PENDING_APPROVAL', label: 'Pending Approval', class: 'warning' };
const REJECTED: FilterToggleOption = { key: 'REJECTED', label: 'Rejected', class: 'danger' };

// Only offer a pick that can match: the scheduling badges need work order scheduling, and the
// transfer badges need ToC acknowledgement.
export function workOrderStatusButtons(options: { scheduling: boolean; toc: boolean }): FilterToggleOption[] {
  return [
    ALL_STATUSES,
    AVAILABLE,
    ...(options.scheduling ? [SCHEDULED, RESCHEDULE_REQUIRED] : []),
    OPEN,
    ...(options.toc ? [TRANSFER_REQUESTED, RETURN_REQUESTED] : []),
    CLOSED,
    SUSPENDED,
    SURRENDERED,
    PENDING_RELEASE,
    PENDING_APPROVAL,
    REJECTED,
  ];
}

// The portal states behind each pick's label. The badge shows XferAcknowledged and ReturnAcknowledged
// under the plain Transfer Requested and Return Requested labels.
const PORTAL_STATES_BY_STATUS_KEY: { [key: string]: WorkOrderState[] } = {
  [AVAILABLE.key]: [WorkOrderState.Available],
  [SCHEDULED.key]: [WorkOrderState.Scheduled],
  [RESCHEDULE_REQUIRED.key]: [WorkOrderState.Overdue],
  [OPEN.key]: [WorkOrderState.Open],
  [TRANSFER_REQUESTED.key]: [WorkOrderState.PendingXfer, WorkOrderState.XferAcknowledged],
  [RETURN_REQUESTED.key]: [WorkOrderState.PendingReturn, WorkOrderState.ReturnAcknowledged],
  [CLOSED.key]: [WorkOrderState.Closed],
  [SUSPENDED.key]: [WorkOrderState.Suspended],
  [SURRENDERED.key]: [WorkOrderState.Surrendered],
  [PENDING_RELEASE.key]: [WorkOrderState.Approved],
  [PENDING_APPROVAL.key]: [WorkOrderState.Pending],
  [REJECTED.key]: [WorkOrderState.Rejected],
};

// The canonical states a Status pick sends as repeated state parameters; none for All.
export function workOrderStatesForStatus(key: string): CanonicalWorkOrderState[] {
  const portalStates = PORTAL_STATES_BY_STATUS_KEY[key] || [];
  return (Object.keys(PORTAL_STATE_BY_CANONICAL_STATE) as CanonicalWorkOrderState[])
    .filter((state) => portalStates.includes(PORTAL_STATE_BY_CANONICAL_STATE[state]));
}
